import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var REQUEST_KEY = "getProductCampaign";
export var useGetCampaign = function () {
    var dispatch = useDispatch();
    var _a = useRequestState(REQUEST_KEY), data = _a.data, loading = _a.loading, error = _a.error;
    var fetch = function (id) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Campaign/".concat(id),
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return { fetch: fetch, campaign: data, loading: loading, error: error };
};
